import React from "react";
import { Carousel } from "react-responsive-carousel";
import generalInfo from "../../files/Slider.json";

const items = [];

generalInfo.map(function (item, i) {
  if (item.ident === "S" && item.status === "Active") {
    items.push(item);
  }
  return null;
});

const Home_Slider = () => {
  return (
    <Carousel showArrows showThumbs={false} infiniteLoop autoPlay emulateTouch>
      {items.map((item, index) => {
        // if (item.width === "") {
          return (
            <div key={"S" + index}>
              <img src={item.picture} alt={item.title} />
            </div>
          );
        // } else {
        //   return (
        //     <div key={"S" + index}>
        //       <img
        //         src={item.picture}
        //         alt={item.title}
        //         style={{ width: 700}}
        //       />
        //     </div>
        //   );
        // }
      })}
    </Carousel>
  );
};

export default Home_Slider;
